import React, { useState } from "react";
import {NavLink} from "react-router-dom";
import Layout from "../components/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CountryFlags } from "../components/CountryFlags";
import { iso3ForCountry } from "../static/data/iso3";
import countriesInfo from "../static/data/minigrid-app-urls.json";
import { Helmet } from "react-helmet";

export default function Countries() {
  const [expandedIso3, setExpandedIso3] = useState(null);
  const countriesData = countriesInfo
    .map(item => ({
      name: item.country,
      vidaLink: item.vida_link,
      ediLink: item.edi_link,
      iso3: iso3ForCountry(item.country)
    }))
    .filter(d => d.iso3 && d.vidaLink && d.ediLink);

  return (
    <Layout>
      <Helmet>
        <title>Distributed Renewable Energy (DRE) Atlas - Countries</title>
        <meta name="description" content="Click on a country to access the DRE Atlas and underlying raw settlement data for that country." />
      </Helmet>
      <div id="countries-container">
             <section>
        <h1 className="text-yellow">Explore Country Platforms</h1>
        <h5 className="page-description">Click on a country to access the DRE Atlas and underlying raw settlement data for that country.</h5>
      </section>

      <section>
        <div className="country-grid">
          {countriesData.map(country => (
            <div key={country.iso3} className="country-card">
              <div onClick={() => setExpandedIso3(expandedIso3 === country.iso3 ? null : country.iso3)}>
                <CountryFlags iso3={country.iso3} width="50px" />
                <div className="country-text"><div>{country.name}</div></div>
              </div>
              {expandedIso3 === country.iso3 && (
                <div className="country-links">
                  <div>
                    <a href={country.vidaLink} target="_blank" rel="noopener noreferrer" className="btn btn-white-alt">View Atlas</a>
                  </div>
                  <div>
                    <a href={country.ediLink} target="_blank" rel="noopener noreferrer" className="btn btn-navy-blue-alt">View Data</a>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
      </div>
    </Layout>
  );
}
